import { render, staticRenderFns } from "./ClubModal.vue?vue&type=template&id=67b6adfa&scoped=true"
import script from "./ClubModal.vue?vue&type=script&lang=ts"
export * from "./ClubModal.vue?vue&type=script&lang=ts"
import style0 from "./ClubModal.vue?vue&type=style&index=0&id=67b6adfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b6adfa",
  null
  
)

export default component.exports